export const RuleSeverity = {
  None: 'none',
  Error: 'error',
  Warning: 'warning',
  Note: 'note',
  Nit: 'nit',
  Low: 'low',
  Medium: 'medium',
  High: 'high',
  Critical: 'critical',
} as const

export type RuleSeverity = (typeof RuleSeverity)[keyof typeof RuleSeverity]
